<template>
  <div class="user_container" v-if="userlistviewshow">
    <div class="left_box el-tabs--border-card">
      <div class="title"><i class="el-icon-s-fold"></i> 人员管理</div>
      <TreeComp
        :tree-data="list"
        :show-edit="false"
        @treeClick="treeClick"
        :currentNodekeyNum="currentNodekey"
        :treeLoading="treeLoading"
      ></TreeComp>
    </div>
    <div class="right_box">
      <MainTabBar
        :activename="activeName"
        :tabitem="tabItem"
        @handleTabClick="handleTabClick"
        @closeTab="closeTab"
      >
        <!-- v-if="tableColumn.length" -->
        <div :slot="tabItem[0].label">
          <el-row
            type="flex"
            class="row-bg top-box"
            justify="space-between"
            style="padding: 0 15px 0 15px; font-size: 12px"
          >
            <el-col :span="6" v-show="showDestination_id">
              <el-button
                size="mini"
                type="primary"
                @click="handleAdd"
                v-if="userlistaddshow"
                >新增</el-button
              >
              <el-button size="mini" type="primary" @click="exportdata"
                >导出</el-button
              >
            </el-col>
            <el-form
              @submit.native.prevent
              :inline="true"
              v-show="showDestination_id"
            >
              <el-form-item label="姓名：" style="font-size: 12px">
                <el-input
                  size="mini"
                  @keyup.enter.native="onQuery"
                  clearable
                  v-model.trim="searchKey"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  size="mini"
                  type="primary"
                  @click="onQuery"
                  icon="el-icon-search"
                  >查询</el-button
                >
              </el-form-item>
            </el-form>
          </el-row>
          <TableComp
            :table-column="tableColumn"
            :table-data="tableData"
            :total="total"
            :loading="loading"
            :lists="lists"
            @editRow="editRow"
            @delRow="delRow"
            @handlePageChange="handlePageChange"
          ></TableComp>
        </div>
        <div :slot="tabEditLabel">
          <div class="fromContainer">
            <!-- <el-scrollbar style="height: 100%;" wrap-style="overflow-x:hidden;"> -->
            <el-form
              :model="form"
              status-icon
              :rules="rules"
              ref="form"
              label-width="100px"
              size="mini"
              labelWidth="auto"
              style="width: 100%; font-size: 12px; margin-top: 20px"
            >
              <!-- left -->
              <el-row :gutter="20">
                <el-col :sm="24" :md="18" :lg="18" :xl="12" :offset="0">
                  <el-form-item label="姓名：" prop="name">
                    <el-input v-model.trim="form.name"></el-input>
                  </el-form-item>
                  <el-form-item label="手机号：" prop="mobile">
                    <el-input v-model.trim="form.mobile"></el-input>
                  </el-form-item>
                  <el-form-item label="登录密码：" prop="password">
                    <el-input
                      v-model.trim="form.password"
                      @input="changeInput"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="类型：" prop="type">
                    <el-select
                      v-model="form.type"
                      value-key
                      placeholder
                      clearable
                      filterable
                      @change="quanxian"
                    >
                      <el-option
                        v-for="item in statusLists"
                        :key="item.key"
                        :label="item.status_name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item
                    label="权限："
                    prop="jurisdiction"
                    v-if="
                      this.Moduleconfigrichangs.length == 0 &&
                      this.Moduleconfigshebeis.length == 0
                        ? false
                        : true
                    "
                  >
                    <div
                      style="margin: 0; padding: 0"
                      v-if="
                        this.Moduleconfigrichangs.length == 0 ? false : true
                      "
                    >
                      <span style="color: #6495ed"> 日常工作 </span>
                      <el-checkbox-group v-model="form.right">
                        <el-checkbox
                          v-for="item in Moduleconfigrichangs"
                          :label="item.code"
                          :key="item.row_id"
                          >{{ item.name }}</el-checkbox
                        >
                      </el-checkbox-group>
                    </div>
                    <div
                      style="margin: 0; padding: 0"
                      v-if="this.Moduleconfigshebeis.length == 0 ? false : true"
                    >
                      <span style="color: #6495ed"> 设备管控 </span>
                      <el-checkbox-group v-model="form.right">
                        <el-checkbox
                          v-for="item in Moduleconfigshebeis"
                          :label="item.code"
                          :key="item.row_id"
                          >{{ item.name }}</el-checkbox
                        >
                      </el-checkbox-group>
                    </div>
                  </el-form-item>

                  <el-form-item label="性别：" prop="sex">
                    <el-select
                      v-model="form.sex"
                      value-key
                      placeholder
                      clearable
                      filterable
                    >
                      <el-option label="男" :value="0"></el-option>
                      <el-option label="女" :value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="出生年月：" prop="birthday">
                    <el-date-picker
                      v-model="form.birthday"
                      type="date"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="民族：" prop="nationality">
                    <el-input v-model.trim="form.nationality"></el-input>
                  </el-form-item>
                  <el-form-item label="绑定账户：" prop="account_id">
                    <el-select
                      v-model="form.account_id"
                      value-key
                      placeholder
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in accounts"
                        :key="item.key"
                        :label="item.account"
                        :value="item.row_id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="部门：" prop="department">
                    <el-select
                      v-model="form.department"
                      value-key
                      placeholder
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in lists"
                        :key="String(item.row_id)"
                        :label="item.name"
                        :value="String(item.row_id)"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label>
                    <el-button type="primary" size="mini" @click="confirm(form)"
                      >保存</el-button
                    >
                    <el-button size="mini" @click="closeTab('edit')"
                      >取消</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <!-- </el-scrollbar> -->
          </div>
        </div>
      </MainTabBar>
    </div>
  </div>
</template>
  <script lang="js">
  import TreeComp from '../../components/Usercomp/TreeComp';
  import MainTabBar from '../../components/maintabbar/MainTabBar';
  import TableComp from '../../components/tablecomp/TableComp';
  import  request  from '../../dataApi/_request';
  import Api from '../../api/usercApi';
  import md5 from 'js-md5';
  import xlsx from 'xlsx'
  export default {
    components: {
      TreeComp,
          MainTabBar,
      TableComp
    },
    props:{
        userdata:{
              type: Object,
              default:{}
        }
    },
    watch:{

    },
    data() {
      return {
        statusLists:[{id:0,status_name:'普通员工'},{id:1,status_name:'房屋租户'},{id:2,status_name:'管理人员'}],
        list: [],//存储树状结构
        lists:[],//存储非树状结构
        Appconfig:'',
        Appconfigrow_id:null,
        Moduleconfig:[],
        Moduleconfigrichang:[],
        Moduleconfigrichangs:[],
        Moduleconfigshebei:[],
        Moduleconfigshebeis:[],
        ModuleConfigData:[],
        names:0,
        tableColumn: [
          {
            label: "姓名",
            prop: "name",
            fristEnten: true, //首列
            func: "editRow" //点击的方法
          },
          {
            label: "手机号",
            prop: "mobile"
          },
          {
            label: "部门",
            prop: "department",
          },
          {
            label: "出生年月",
            prop: "birthday",
          },
          {
            label: "操作",
            //是否是操作
            isAction: true,
            fixed: "right",
            //操作的按钮与方法
            actionItem: [
              {
                text: "编辑", //按钮的文本
                icon: "el-icon-edit",
                type: "primary", //按钮类型
                func: "editRow", //按钮的方法
              },
            ],
            //带确认的按钮
            popconfirmitem: [
              {
                text: "删除",
                icon: "el-icon-delete",
                func: "delRow",
                title: "确定删除这条数据吗？",
              },
            ],
          }
        ],
        tableData: [],
        total: 0,
        searchKey: '',
        activeName: '',
        tabItem: [
          {
            name: "init", //移除时使用
            label: "人员查看",
          },
        ],
        //0:普通；1:管理员；2：超级管理员
        typeOptions: [
          {
            label: '普通',
            value: 0
          }, {
            label: '管理员',
            value: 1
          }, {
            label: '超级管理员',
            value: 2
          }
        ],
        form: {},
        rules: {
          name:[{ required: true, message: '请输入姓名', trigger: 'blur' },],
          mobile:[
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { pattern:/^((0\d{2,3}-\d{7,8})|(1[345789]\d{9}))$/, message: "请输入合法手机号", trigger: "blur" }],
          // password:[{ required: true, message: '请输入登陆密码', trigger: 'blur'}],
          //           { min: 6,message: '密码长度不应小于6位'},
              //           {pattern: /^(\w){6,}$/, message: '只能输入6-32个字母、数字、下划线'}],
          // type:[{ required: true, message: '请输入用户类型', trigger: 'blur'}],
          // sex:[{ required: true, message: '请输入性别', trigger: 'blur'}],
          // birthday:[{ required: true, message: '请输入出生年月', trigger: 'blur'}],
          // nationality:[{ required: true, message: '请输入民族', trigger: 'blur'},
          // { pattern:/^[\u4e00-\u9fa5]+$/, message: "民族应为汉字", trigger: "blur" },

        },
        treeSeleteData: {},
        tabEditLabel: '',
        loading:true,
        currentNodekey:null,
        treeLoading:true,
        tableDataJudgment:[],
        pageNum:20,
        showDestination_id:true,
        userInfo:[],
        userlistviewshow:true,
        userlistaddshow:true,
        userlistmodifyshow:true,
        userlistdelshow:true,
        accounts:[]
        // userdata:{data:{destination_id:64}}
      };
    },
    mounted() {
      if (this.userdata.destination_id) {
        this.getAppconfig()
        this.getTreeData()
        this.getAccount()
        this.getTableDataJudgment()
      } else {
        this.treeLoading = false
        this.showDestination_id = false
        this.loading = false
      }
    },
    created() {
      this.userInfo = this.$store.state.userInfo.data.right
      this.userlistChioce()
    },
    methods: {
      exportdata(){
      const workBook = xlsx.utils.book_new()
  // 2. 创建工作表 worksheet
  
const header = {
  name: '姓名', mobile: '手机号', department: '部门',sex:"性别", birthday: '出生年月',nationality:"民族"
}
let lists=this.tableData.map(item => {
  const obj = {}
  let item2=JSON.parse(JSON.stringify(item))
  item2['sex']=item2['sex']==0?'男':'女'
  for (const key in header) {
    if (item2[key]) {
        obj[header[key]] = item2[key]
    } else {
      obj[header[key]] = ''
    }
  }
  return obj
})
const objects = lists;
const workSheet = xlsx.utils.json_to_sheet(lists)
  // 3. 将工作表放入工作簿中
  xlsx.utils.book_append_sheet(workBook, workSheet)
  // 4. 生成数据保存
  xlsx.writeFile(workBook, `人员列表.xlsx`, {
    bookType: 'xlsx'
  })

      },
      //查询绑定账户选项
      getAccount(){
           var params={
            method:'get',
            url:Api.getAccount,
            params:{data:{destination_id:this.$store.state.userInfo.data.destination_id,type:2}}
          }
          request(params).then((result) => {
            this.accounts=result.data.list
            this.ensureAccountValid()
          }).catch((err) => {
            
          });
      },
      ensureAccountValid(){
        if (!this.form || !this.form.account_id) {
          return
        }
        const exists = this.accounts.some(item => item.row_id == this.form.account_id)
        if (!exists) {
          this.form.account_id = ''
        }
      },
      // 权限功能
      userlistChioce(){
        if (this.userInfo) {
          if (this.userInfo.userlistview == false) {
            this.$message("暂无查看权限")
            this.userlistviewshow = false
          }

          if (this.userInfo.userlistadd == false) {
            this.userlistaddshow = false
          }

          if (this.userInfo.userlistmodify == false) {
            this.userlistmodifyshow = false
          }

          if (this.userInfo.userlistdel == false) {
            this.userlistdelshow = false
          }
        }
      },

      treeList(arr){
            let parents = arr.filter(value => value.parent_id == 'undefined' || value.parent_id == null)
                  let children = arr.filter(value => value.parent_id !== 'undefined' && value.parent_id != null)
                  let translator = (parents, children) => {
                      parents.forEach((parent) => {
                          children.forEach((current, index) => {
                              if (current.parent_id === parent.row_id) {
                                  let temp = JSON.parse(JSON.stringify(children))
                                  temp.splice(index, 1)
                                  translator([current], temp)
                                  typeof parent.children !== 'undefined' ? parent.children.push(current) : parent.children = [current]
                              }
                          }
                          )
                      }
                      )
                  }
                  translator(parents, children)
                  return parents
      },

      // 修改用户信息时，密码输入框选中输入文字不更新视图，强制刷新一下
      changeInput(){
        this.$forceUpdate()
      },

      quanxian(val){
        if (this.tabEditLabel == '新增') {
          if (val == 1 || val == 2) {
            this.form.right = this.Appconfig
          } else if (val == 0) {
            this.form.right = []
          }
        }
      },

      // 大权限接口
      getAppconfig() {
        if (this.userdata.destination_id) {
          var params={
            method:'get',
            url:Api.getAppconfig,
            params:{destination_id:this.userdata.destination_id}
          }
        } else if(this.userdata.data.destination_id){
          var params={
            method:'get',
            url:Api.getAppconfig,
            params:{destination_id:this.userdata.data.destination_id}
          }
        }
        request(params).then((result) => {
          // let children = this.treeList(result.data.list)
          this.Appconfig = ''
          this.Appconfigrow_id=null
          this.Moduleconfig=[]
          this.Moduleconfigrichang=[]
          this.Moduleconfigrichangs=[]
          this.Moduleconfigshebei=[]
          this.Moduleconfigshebeis=[]
          this.ModuleConfigData=[]
          var arr = []
          for (let i = 0; i < result.data.list[0].app_right.length; i++) {
            if (result.data.list[0].app_right.split(',')[i]) {
              arr.push(result.data.list[0].app_right.split(',')[i])
            }
          }
          this.Appconfigrow_id = result.data.list[0].row_id
          this.Appconfig = arr
          // console.log(result,'result,大权限',this.Appconfig);
          this.getModuleconfig()
        }).catch((err) => {
        });
      },

      // 权限接口
      getModuleconfig() {
        if (this.userdata.destination_id) {
          var params={
            method:'get',
            url:Api.getModuleconfig,
            params:{pageNum:100}
          }
        } else if(this.userdata.data.destination_id){
          var params={
            method:'get',
            url:Api.getModuleconfig,
            params:{pageNum:100}
          }
        }
        request(params).then((result) => {
          // let children = this.treeList(result.data.list)
          this.Moduleconfig = result.data.list
          for (let i = 0; i < this.Moduleconfig.length; i++) {
            if (this.Moduleconfig[i].type == 1) {
              this.Moduleconfigrichang.push(this.Moduleconfig[i])
            } else if (this.Moduleconfig[i].type == 2){
              this.Moduleconfigshebei.push(this.Moduleconfig[i])
            }
          }
          for (let i = 0; i < this.Appconfig.length; i++) {
            for (let w = 0; w < this.Moduleconfigrichang.length; w++) {
              if (this.Moduleconfigrichang[w].code == this.Appconfig[i]) {
                this.Moduleconfigrichangs.push(this.Moduleconfigrichang[w])
              }
            }
            for (let q = 0; q < this.Moduleconfigshebei.length; q++) {
              if (this.Moduleconfigshebei[q].code == this.Appconfig[i]) {
                this.Moduleconfigshebeis.push(this.Moduleconfigshebei[q])
              }
            }
          }
          // console.log(result,'result,权限',this.Moduleconfigshebei,this.Moduleconfigshebeis,this.Moduleconfigrichang,this.Moduleconfigrichangs);
        }).catch((err) => {
        });
      },


      getTreeData() {
        if (this.userdata.destination_id) {
          var params={
            method:'get',
            url:Api.getTreeData,
            params:{param:{order_by:"row_id asc"},pageNum:999,destination_id:this.userdata.destination_id}
          }
        } else if(this.userdata.data.destination_id){
          var params={
            method:'get',
            url:Api.getTreeData,
            params:{param:{order_by:"row_id asc"},pageNum:999,destination_id:this.userdata.data.destination_id}
          }
        }

        request(params).then((result) => {
          this.lists = result.data.list //没有进行树状结构处理的数据
          let children = this.treeList(result.data.list)
          this.list =[{row_id:-1,name:'部门列表',children:children}]
          this.childrenFirst(this.list)
          this.treeLoading = false
          this.getTableData()
        }).catch((err) => {
        });
      },
      childrenFirst(list){
          this.currentNodekey = list[0].row_id
          this.treeSeleteData = list[0]
      },
      getTableData(){
        if (this.userdata.destination_id) {
          var params={
            method:'get',
            url:Api.getTableData,
            params:{data:{department_id:this.treeSeleteData.row_id,name:'',searchmodel:"exact"},destination_id:this.userdata.destination_id,pageNum:this.pageNum,item:'name',item_like:this.searchKey}
          }
        } else if(this.userdata.data.destination_id){
          var params={
            method:'get',
            url:Api.getTableData,
            params:{data:{department_id:this.treeSeleteData.row_id,name:'',searchmodel:"exact"},destination_id:this.userdata.data.destination_id,pageNum:this.pageNum,item:'name',item_like:this.searchKey}
          }
        }
        request(params).then((result) => {
          let {list, total } = result.data
          if (result.errcode == 0) {
            this.tableData = list
            this.total = total

          }
          this.loading = false
          // console.log(this.tableData,"tableData");
          // this.list = result.data.data
        }).catch((err) => {
        });
      },
      getTableDataTreeHead(){
        if (this.userdata.destination_id) {
          var params={
            method:'get',
            url:Api.getTableData,
            params:{data:{department_id:-1,name:this.searchKey,searchmodel:"exact"},destination_id:this.userdata.destination_id}
          }
        } else if(this.userdata.data.destination_id){
          var params={
            method:'get',
            url:Api.getTableData,
            params:{data:{department_id:-1,name:this.searchKey,searchmodel:"exact"},destination_id:this.userdata.data.destination_id}
          }
        }
        request(params).then((result) => {
          let {list, total } = result.data
          if (result.errcode == 0) {
            this.tableData = list
            this.total = total
          }
          this.loading = false
        }).catch((err) => {
        });
      },
      getTableDataJudgment(){
        if (this.userdata.destination_id) {
          var params={
            method:'get',
            url:Api.getTableData,
            params:{data:{name:this.searchKey,searchmodel:"exact"},destination_id:this.userdata.destination_id,pageNum:this.pageNum}
          }
        } else if(this.userdata.data.destination_id){
          var params={
            method:'get',
            url:Api.getTableData,
            params:{data:{name:this.searchKey,searchmodel:"exact"},destination_id:this.userdata.data.destination_id,pageNum:999}
          }
        }
        request(params).then((result) => {
          let {list, total } = result.data
          if (result.errcode == 0) {
            this.tableDataJudgment = list
          }
        }).catch((err) => {
        });
      },
      handlePageChange(val,wal){
        this.pageNum = wal
        if (this.userdata.destination_id) {
          var params={
            method:'get',
            url:Api.getTableData,
            params:{pageNo:val,pageNum:wal,data:{department_id:this.treeSeleteData.row_id,name:this.searchKey,searchmodel:"exact"},destination_id:this.userdata.destination_id}
          }
        } else if(this.userdata.data.destination_id){
          var params={
            method:'get',
            url:Api.getTableData,
            params:{pageNo:val,pageNum:wal,data:{department_id:this.treeSeleteData.row_id,name:this.searchKey,searchmodel:"exact"},destination_id:this.userdata.data.destination_id}
          }
        }
        request(params).then((result) => {
          let {list, total } = result.data
          if (result.errcode == 0) {
            this.tableData = list
            this.total = total
          }
        }).catch((err) => {
        });
      },
      treeClick(data) {
        if (this.tabEditLabel != '人员查看') {
          this.closeTab('edit')
        }
        this.treeSeleteData = data
        this.loading = true
        this.searchKey = ''
        if (data.row_id == -1) {
          this.getTableDataTreeHead()
        } else {
          this.getTableData()
        }
        this.getAppconfig()
      },
      handleAdd() {
        this.activeName = "edit";
        this.tabEditLabel = "新增";
        this.form={type:0,right:[],department:String(this.treeSeleteData.row_id)};
        if(this.treeSeleteData.row_id == -1){
          this.form.department = ''
        }
        if (!this.isTabOpen(this.activeName)) {
          this.tabItem.push({
            name: "edit", //移除时使用
            label: "新增",
            closable: true,
          })
        } else {
          this.tabItem[1].label = this.tabEditLabel; //打开就直接变个标题 合理！这个想法恒河里
        }
      },
      editRow(row, field){
        // console.log(row,'row');
        if (this.userlistChioce && this.userlistmodifyshow == false) {
          this.$message('暂无修改权限')
        } else {
          this.form = JSON.parse(JSON.stringify(row));
          //点击编辑时标签页title
          this.tabEditLabel = this.form.name + "-编辑";
          this.activeName = "edit";
          if (this.form.account_id==0) {
            this.form.account_id=''
          }

          this.ensureAccountValid()
          this.form.password = '******'
          var arr = []
          for (let i = 0; i < row.right.length; i++) {
            if (row.right.split(',')[i]) {
              arr.push(row.right.split(',')[i])
            }
          }
          this.form.right = arr
          if (!this.isTabOpen(this.activeName)) {
            this.tabItem.push({
              name: "edit",
              label: this.tabEditLabel,
              closable: true,
            });
          } else {
            this.tabItem[1].label = this.tabEditLabel;
          }
        }
      },
      closeTab(name) {
        this.activeName = "init";
        this.form = {}
        this.tabItem.forEach((element, index) => {
          if (element.name == name) {
            this.tabItem.splice(index, 1);
          }
        });
      },
      // 删除用户事件
      delRow(row) {
        if (this.userInfo && this.userlistdelshow == false) {
          this.$message("暂无删除权限")
        } else {
          let row_id = row.row_id
          this.deleteTableData(row_id)
          this.loading = true
          this.getTableData()
        }
      },
      // 删除用户函数
      deleteTableData(row_id){
        let params = {
          method: 'get',
          url: Api.deleteTableData,
          params: {  row_id}// code usercenterdepartment
        }
        request(params).then((result) => {
           if(result.errcode == 0){
            this.$message({
                  message: '删除成功',
                  type: 'success',
            duration:1000
            });

          }else{
            this.$message.error('删除失败');
          }
          this.getTableData()
        }).catch((err) => {
        });
      },
      handleTabClick(tab) {
        let { name } = tab
        this.activeName = name;
      },
      //判断标签页是否已经打开
      isTabOpen(value) {
        return (
          this.tabItem.findIndex((val) => {
            return [value].includes(val.name);
          }) > -1
        );
      },
      // 确认添加or修改
      confirm(form) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if(this.tabEditLabel == '新增'){
              this.addTableData()
            }else{
              this.modifyTableData()
            }

          } else {
            return false;
          }
        });
      },


      // 修改用户方法
      modifyTableData(){
         let { name, remark,password,type,sex,birthday,nationality,row_id,department,mobile,account_id,} = this.form
         if (account_id=="") {
          account_id=0
         }
         let department_id=department
         let right = this.form.right.toString()
           let params = {
            method: 'get',
            url: Api.modifyTableData,
            params:{}// code usercenterdepartment
          }
        if (birthday == null) {
          birthday = ""
        }
         if(password == '******'){
           params.params = { row_id:row_id,data:{name, remark,department,type,sex,birthday,nationality,mobile,right,account_id,department_id}}
          }else{
            params.params = { row_id:row_id,data:{name, remark,password,department,type,sex,birthday,nationality,mobile,right,account_id,department_id}}
         }
          request(params).then((result) => {
            if(result.errcode == 0){
              this.$message({
                    message: '修改成功',
                    type: 'success',
            duration:1000
              });

            }else{
              this.$message.error('修改失败');
            }
            this.loading = true
            this.getTableData()
          }).catch((err) => {
          });
          this.closeTab('edit')
      },
      // 添加用户方法
      addTableData(){
         let { name, remark,password,type,sex,birthday,nationality,mobile,account_id} = this.form
         let department_id =this.form.department?this.form.department:this.treeSeleteData.row_id
         let department = this.form.department?this.form.department:this.treeSeleteData.name
         let right = this.form.right.toString()
         
          if (this.userdata.destination_id) {
            var params = {
              method: 'get',
              url: Api.addTableData,
              params: { data:{name,remark,password,department,department_id,type,sex,birthday,nationality,mobile,right,account_id,},destination_id:this.userdata.destination_id}
            }
          } else if(this.userdata.data.destination_id){
            var params = {
              method: 'get',
              url: Api.addTableData,
              params: { data:{name,remark,password,department,department_id,type,sex,birthday,nationality,mobile,right,account_id,},destination_id:this.userdata.data.destination_id}
            }
          }
        if (birthday == null) {
          birthday = ""
        }
        for (let i = 0; i < this.tableDataJudgment.length; i++) {
          if (this.tableDataJudgment[i].name == name) {
            this.names = 1
          }
        }
        if (this.names == 0) {
          request(params).then((result) => {
            if(result.errcode == 0){
              this.$message({
                message: '添加成功',
                type: 'success',
            duration:1000
              });
            }else{
              this.$message.error('添加失败');
            }
            this.loading = true
            if (department_id == -1) {
              this.getTableDataTreeHead()
            } else {
              this.getTableData()
            }
          }).catch((err) => {
          });
          this.closeTab('edit')
        } else if (this.names == 1) {
          this.$message.error("该用户已此列表或其他列表存在")
          this.names = 0
        }

      },

      onQuery() {
        this.loading = true
        this.total = 1
        this.getTableData()
      }
    },
  };
  </script>
  <style lang="less" scoped>
@baseColor: #05adaa;
.user_container {
  .el-select,
  .el-date-editor {
    width: 100%;
  }

  display: flex;

  .left_box {
    width: 200px;
    height: calc(100vh - 5px);
    .title {
      text-align: left;
      font-size: 14px;
      color: @baseColor;
      padding-left: 5px;
      height: 40px;
      line-height: 40px;
    }
  }
  .right_box {
    flex: 1;
    overflow: hidden;
    .fromContainer {
      padding-left: 20px;
      height: calc(100vh - 7vh);
      overflow-y: scroll;
      overflow-x: hidden;
    }
  }
}
.tab_style {
  height: 99.9vh;
}
.listyle {
  background-color: antiquewhite;
}
/deep/.el-tabs__content {
  padding: 0 !important;
}
/deep/ .el-form-item__label {
  font-size: 12px;
}
/deep/ .el-pagination span:not([class*="suffix"]),
.el-pagination button {
  font-size: 12px;
}
/deep/.el-scrollbar__wrap {
  overflow-x: hidden;
  overflow-y: scroll;
}
// /deep/.el-scrollbar__thumb {
//   width: 0 !important;
// }
/deep/.el-scrollbar {
  height: 95vh !important;
}
// .el-message{margin-top: 400px !important;}
</style>
